// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  border: 1px dashed var(--bs-primary);
  min-height: unset;
}

.dropzone .dz-message {
  margin: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/upload-image/upload-image.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,iBAAA;AACJ;;AAEC;EACI,aAAA;AACL","sourcesContent":[".dropzone {\n    border: 1px dashed var(--bs-primary);\n    min-height: unset;\n } \n \n .dropzone .dz-message {\n     margin: unset;\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
